import { Controller } from "@hotwired/stimulus"

// A <details> dropdown that closes when you click outside it or press Esc. Native <details> only closes
// when its own summary is re-clicked, which reads as broken for a filter dropdown left open over the page.
// (Applying the filter is a separate concern — the `auto-submit` controller on the enclosing form submits
// on change; because that form is OUTSIDE the leaderboard frame, the list updates without closing this
// dropdown.) Listeners live on `this` and are torn down on disconnect (incl. when Turbo swaps a frame).
export default class extends Controller {
  connect() {
    this.closeOnOutsideClick = (event) => {
      if (this.element.open && !this.element.contains(event.target)) this.element.open = false
    }
    this.closeOnEscape = (event) => {
      if (event.key === "Escape" && this.element.open) this.element.open = false
    }
    document.addEventListener("click", this.closeOnOutsideClick)
    document.addEventListener("keydown", this.closeOnEscape)
  }

  disconnect() {
    document.removeEventListener("click", this.closeOnOutsideClick)
    document.removeEventListener("keydown", this.closeOnEscape)
  }
}
